module.exports = __webpack_public_path__ + "faeeae2f72efece0a3d237bf2b8d1844.png";